import { render, staticRenderFns } from "./TestTaskDetail.vue?vue&type=template&id=7aa4e872"
import script from "./TestTaskDetail.vue?vue&type=script&lang=js"
export * from "./TestTaskDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports